import { useOktaAuth } from "@okta/okta-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import UserDetailResponse from "../../models/API/responseModels/userDetailResponse.model";
import { useEffect } from "react";

interface UsersListResponse {
  user: UserDetailResponse;
  data: UserDetailResponse;
}

function useSinglePortalUser(
  id: string
): UseQueryResult<UsersListResponse, any> {
  const data = useOktaAuth();
  const authState = data?.authState;

  return useQuery({
    queryKey: ["userDetail", id],
    queryFn: ({ queryKey }) => {
      const [_key, id] = queryKey;

      return axiosInstance
        .get(`/v1/users/new-flow/${id}`, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data);
    },
    enabled: !!id && !!authState?.accessToken?.accessToken, // Ensure the query only runs if id & token is available
  });
}

export default useSinglePortalUser;
